import { createPortal } from "react-dom";
import { create } from "zustand";

type SecondaryFloatingPanelsStore = {
  isSecondaryPanelDisplayed: boolean;
  setIsSecondaryPanelDisplayed: (isSecondaryPanelDisplayed: boolean) => void;
};

export const useSecondaryFloatingPanelsStore =
  create<SecondaryFloatingPanelsStore>((set) => ({
    isSecondaryPanelDisplayed: false,
    setIsSecondaryPanelDisplayed: (isSecondaryPanelDisplayed) =>
      set({ isSecondaryPanelDisplayed }),
  }));

export function SecondaryPanelOverlay() {
  const { isSecondaryPanelDisplayed, setIsSecondaryPanelDisplayed } =
    useSecondaryFloatingPanelsStore();

  return isSecondaryPanelDisplayed
    ? createPortal(
        <div
          className="fixed top-0 left-0 z-10 w-full h-full"
          onClick={() => {
            setIsSecondaryPanelDisplayed(false);
          }}
        />,
        document.body
      )
    : null;
}
